export const coachVideoApi = '/api/v1/videos/coach_video/';